var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForecastEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 164.44 19.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;font-family:'Avenir Next','Avenir','Montserrat','Helvetica Neue','Segoe UI',Arial,sans-serif;font-size:19px;font-weight:400;letter-spacing:-0.2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    x: "50%",
    y: 15,
    textAnchor: "middle"
  }, "ForecastEDGE"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastEdge);
export default __webpack_public_path__ + "static/media/ForecastEDGE.e0f18f1d9284821a89677ee517ee5e02.svg";
export { ForwardRef as ReactComponent };